import { NavItem } from '../types/NavItem';
import { NavItemLink } from '../interfaces/NavItemLink';

export class NavItemService {
  static isNavLink(item: NavItem): item is NavItemLink {
    return !!(item as NavItemLink).path;
  }
}
